import { Routes } from '@angular/router';

import { AgentGuard } from '@core/guards/agent.guard';
import { CompositeRouteGuard } from '@core/guards/composite.guard';

import { AgentRoutes } from './agent/agent.routes';
import { LifePlanRoutes } from './life-plan/life-plan.routes';
import { MsalGuard } from '@azure/msal-angular';

export const GeneralRoutes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
    data: { routeGuards: [AgentGuard] },
    canActivate: [CompositeRouteGuard]
  },
  ...AgentRoutes,
  ...LifePlanRoutes
];
